const COOKIE_NAME = 'tgv_search_filters';
const COOKIE_EXPIRE_DAYS = 1;
const COOKIE_SECURED = window.location.protocol === 'https:';

export const getSearchFilters = () => {
  const value = App.es6.shared.cookie.get(COOKIE_NAME);
  if (!value) {
    return null;
  }
  return JSON.parse(value);
};

export const setSearchFilters = (value) => {
  if (!value) {
    throw new Error(`Tried to set search filters, but seems to be falsy value: "${value}"`);
  }

  App.es6.shared.cookie.set(
    COOKIE_NAME,
    JSON.stringify(value),
    COOKIE_EXPIRE_DAYS,
    COOKIE_SECURED,
  );
};
